var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    [
      _c(
        "v-dialog",
        {
          attrs: { lazy: "", "max-width": "500" },
          on: {
            input: function(v) {
              return v
            }
          },
          model: {
            value: _vm.showAcceptBidDialog,
            callback: function($$v) {
              _vm.showAcceptBidDialog = $$v
            },
            expression: "showAcceptBidDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-4" },
            [
              _c(
                "v-layout",
                { attrs: { column: "" } },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { card: "" } },
                    [
                      _c("v-toolbar-title", [
                        _vm._v("Accept Bid " + _vm._s(_vm.bid.humanId))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "title mt-2" }, [
                    _vm._v(_vm._s(_vm.bid.truckingCompany.name))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "subheading mt-2" }, [
                    _vm._v(_vm._s(_vm._f("formatDate")(_vm.bid.pickupTime)))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("span", { staticClass: "subheading mb-3 mt-2" }, [
                        _vm._v("$" + _vm._s(_vm.bid.amount.toFixed(2)))
                      ]),
                      _vm._v(" "),
                      _vm.loadCustomerName
                        ? _c(
                            "v-chip",
                            {
                              attrs: {
                                "text-color": "white",
                                color:
                                  _vm.loadDispatchSpread < 0 ? "red" : "green",
                                small: ""
                              }
                            },
                            [
                              _vm._v(
                                "\n            $" +
                                  _vm._s(_vm.loadDispatchSpread) +
                                  "\n          "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("i", [
                    _vm._v("Offered loads: " + _vm._s(_vm.offeredLoads))
                  ]),
                  _vm._v(" "),
                  _c("v-select", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value:
                          "required|min_value:1|max_value:" + _vm.offeredLoads,
                        expression:
                          "`required|min_value:1|max_value:${offeredLoads}`"
                      }
                    ],
                    attrs: {
                      items: _vm.loadsOptions,
                      "error-messages": _vm.errors.first(
                        "offeredLoads",
                        "modal"
                      ),
                      "data-vv-as": "Offered Loads",
                      "data-vv-name": "offeredLoads",
                      "data-vv-scope": "modal",
                      label: "Accepted Loads"
                    },
                    model: {
                      value: _vm.acceptedLoads,
                      callback: function($$v) {
                        _vm.acceptedLoads = _vm._n($$v)
                      },
                      expression: "acceptedLoads"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "accent",
                            loading: _vm.loadingBtn,
                            disabled: _vm.errors.any("modal")
                          },
                          on: {
                            click: function($event) {
                              return _vm.acceptBidTrucks()
                            }
                          }
                        },
                        [_vm._v("\n            Accept\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "accent", flat: "" },
                          on: { click: _vm.closeAcceptBidDialog }
                        },
                        [_vm._v("\n            Cancel\n          ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            lazy: "",
            "max-width": _vm.$vuetify.breakpoint.smAndDown ? "90%" : "600px"
          },
          model: {
            value: _vm.showTimelineDialog,
            callback: function($$v) {
              _vm.showTimelineDialog = $$v
            },
            expression: "showTimelineDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-4" },
            [
              _c("bid-conversation", {
                attrs: { "bid-id": _vm.bid.id, "disable-form": false }
              }),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "accent" },
                      on: { click: _vm.closeTimelineDialog }
                    },
                    [_vm._v("\n          Close\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "mr-3 mb-3" },
        [
          _c(
            "v-container",
            { staticClass: "pt-1 pr-1" },
            [
              _c(
                "v-toolbar",
                { staticClass: "pl-0 ml-0", attrs: { card: "", dense: "" } },
                [
                  _c(
                    "v-chip",
                    [
                      _c(
                        "v-avatar",
                        { staticClass: "primary" },
                        [
                          _c("v-icon", { attrs: { color: "white" } }, [
                            _vm._v("local_shipping")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("strong", [_vm._v(_vm._s(_vm.bid.numberOfLoads))])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-toolbar-title", { staticClass: "pb-0 mb-0" }, [
                    _vm._v(
                      "\n          $" + _vm._s(_vm.bid.amount) + "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c("v-subheader", [_vm._v(_vm._s(_vm.bid.humanId))]),
                  _vm._v(" "),
                  _c(
                    "v-chip",
                    { attrs: { small: "", color: _vm.bidChipColor } },
                    [
                      _vm.isBidActive
                        ? _c("v-icon", { attrs: { color: "white" } }, [
                            _vm._v("local_offer")
                          ])
                        : _vm.isBidAccepted
                        ? _c("v-icon", { attrs: { color: "white" } }, [
                            _vm._v("done")
                          ])
                        : _c("v-icon", { attrs: { disabled: "" } }, [
                            _vm._v("highlight_off")
                          ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list",
                [
                  _c(
                    "v-list-tile",
                    [
                      _c(
                        "v-list-tile-action",
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                color: _vm.isTCVerified
                                  ? "green"
                                  : "transparent"
                              }
                            },
                            [_vm._v("verified_user")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-content",
                        [
                          _c("v-list-tile-title", [
                            _vm._v(_vm._s(_vm.bid.truckingCompany.name))
                          ]),
                          _vm._v(" "),
                          _c("v-list-tile-sub-title", [
                            _vm._v(
                              "$" +
                                _vm._s(_vm.loadedDistanceBidRate) +
                                "/" +
                                _vm._s(_vm.siteDistanceMeasureUnitLabel) +
                                "\n            "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-avatar",
                        [
                          _vm.loadCustomerName
                            ? _c(
                                "v-chip",
                                {
                                  attrs: {
                                    "text-color": "white",
                                    color:
                                      _vm.loadDispatchSpread < 0
                                        ? "red"
                                        : "green",
                                    small: ""
                                  }
                                },
                                [_vm._v("$" + _vm._s(_vm.loadDispatchSpread))]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile",
                    [
                      _c(
                        "v-list-tile-action",
                        [
                          _c("v-icon", { attrs: { color: "primary" } }, [
                            _vm._v("arrow_upward")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-content",
                        [
                          _c("v-list-tile-title", [
                            _c(
                              "span",
                              {
                                class:
                                  _vm.pickupTimeDifferenceInHours == 0
                                    ? ""
                                    : "font-weight-bold"
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm._f("formatDate")(_vm.bid.pickupTime)
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _vm.pickupTimeDifferenceInHours != 0
                            ? _c("v-list-tile-sub-title", [
                                _c("span", { staticClass: "font-italic" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        Math.abs(
                                          _vm.pickupTimeDifferenceInHours
                                        )
                                      ) +
                                      "\n                hour"
                                  ),
                                  Math.abs(_vm.pickupTimeDifferenceInHours) != 1
                                    ? _c("span", [_vm._v("s")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.pickupTimeDifferenceInHours < 0
                                    ? _c("strong", [_vm._v("Before")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.pickupTimeDifferenceInHours > 0
                                    ? _c("strong", [_vm._v("After")])
                                    : _vm._e(),
                                  _vm._v(
                                    "\n                requested pickup time"
                                  )
                                ])
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.hasInsurancePolicy
                    ? _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-list-tile-action",
                            [
                              _c(
                                "v-icon",
                                { attrs: { color: "green lighten-2" } },
                                [_vm._v("check_circle")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v("Insurance Policy on file")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-list-tile-action",
                            [
                              _c("v-icon", { attrs: { color: "orange" } }, [
                                _vm._v("warning")
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v("Missing Insurance Policy")
                              ]),
                              _vm._v(" "),
                              _c("v-list-tile-sub-title", [
                                _c("span", { staticClass: "font-italic" }, [
                                  _vm._v("not uploaded to profile")
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _vm.hasW9
                    ? _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-list-tile-action",
                            [
                              _c(
                                "v-icon",
                                { attrs: { color: "green lighten-2" } },
                                [_vm._v("check_circle")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "company-profile.vendor-tax-document"
                                    )
                                  ) + " on file"
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-list-tile-action",
                            [
                              _c("v-icon", { attrs: { color: "orange" } }, [
                                _vm._v("warning")
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  "Missing " +
                                    _vm._s(
                                      _vm.$t(
                                        "company-profile.vendor-tax-document"
                                      )
                                    )
                                )
                              ]),
                              _vm._v(" "),
                              _c("v-list-tile-sub-title", [
                                _c("span", { staticClass: "font-italic" }, [
                                  _vm._v("not uploaded to profile")
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile",
                    { on: { click: _vm.openBidTimelineDialog } },
                    [
                      _c(
                        "v-list-tile-action",
                        [
                          _c(
                            "v-icon",
                            { attrs: { flat: "", color: "primary" } },
                            [_vm._v("message")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-content",
                        [
                          _c("v-list-tile-title", [_vm._v("Message Bidder")]),
                          _vm._v(" "),
                          _c("v-list-tile-sub-title", [
                            _vm._v("Resolve questions before accepting bid")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isBidActive
                    ? _c(
                        "v-list-tile",
                        [
                          _c("v-list-tile-action"),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [_vm._v("Accept Bid")]),
                              _vm._v(" "),
                              _c("v-list-tile-sub-title", [
                                _c("span", { staticClass: "font-italic" }, [
                                  _vm._v("and book loads")
                                ])
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-action",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "accent" },
                                  on: { click: _vm.openAcceptBidDialog }
                                },
                                [_c("v-icon", [_vm._v("add_circle")])],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c065b0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c065b0e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/Loads/components/BidCard.vue
// module id = null
// module chunks = 